export function setupLazyImages() {
    document.addEventListener("load", lazyImageEventHandler, { capture: true });
    document.addEventListener("error", lazyImageEventHandler, { capture: true });

    scanLazyImages();
}

export function scanLazyImages() {
    for (const img of document.querySelectorAll("img[loading=lazy]")) {
        if (img instanceof HTMLImageElement) {
            setImageClass(img);
        }
    }
}

function lazyImageEventHandler(ev: Event) {
    const target = ev.target;
    if (target instanceof HTMLImageElement) {
        setImageClass(target);
    }
}

function setImageClass(img: HTMLImageElement) {
    const complete = img.complete;
    if (img.loading === "lazy" && typeof complete === "boolean") {
        img.classList.toggle("loaded", complete);
        img.classList.toggle("loading", !complete);
    }
}
